import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const loansOptionsSlice = createSlice({
  name: 'loans',
  initialState,
  reducers: {
    updateLoanOptions: (state, action) => (action.payload),
    resetPoposal: () => initialState,
  },
});

export const { updateLoanOptions, resetlLoanOptions } = loansOptionsSlice.actions;
export default loansOptionsSlice.reducer;
